import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ResizeObserver loop notifications are benign browser noise, not real errors — CRA's dev
// error overlay treats them as fatal. A plain window 'error' listener can't win against
// react-error-overlay's own earlier-registered listener, so patch ResizeObserver itself
// to swallow the loop error at the source instead.
if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((...args) => {
        window.requestAnimationFrame(() => {
          try { callback(...args); } catch (e) { /* swallow ResizeObserver loop noise */ }
        });
      });
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
